import React, { Component, createRef } from "react";
import { POST, loading, token, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import LOGO from "../assets/images/logo.png";
import LOGO512 from "../assets/images/logo512.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentDidMount() {
    loading(false);
  }
  render() {
    return (
      <div className="w-100 min-vh-100 background position-relative">
        <Navbar />
        {/* SECTION 1 */}
        <div className="w-100 bg-blue text-white align-content-center">
          <div className="container mx-auto px-4 text-center py-5">
            <div className="my-5">
              <h1 className="fw-bold mb-4">เกี่ยวกับ <img alt="LOGO" src={LOGO} className="wpx-200 mx-3" style={{ objectFit: "contain" }} /></h1>
              <h5 className="mb-3">เราคือทีมผู้เชี่ยวชาญด้านเทคโนโลยีที่มุ่งมั่นพัฒนาโซลูชันที่ตอบโจทย์ธุรกิจของคุณ</h5>
             
            </div>
          </div>
        </div>

        {/* SECTION 2 */}
        <div className="w-100 bg-white">
          <div className="container mx-auto p-5 text-center">
            <h1 className="fw-bold mb-4">ระบบธุรกิจ (Business System Analysis)</h1>
            <div className="text-secondary mb-5">เราวิเคราะห์และออกแบบระบบให้เหมาะสมกับธุรกิจของคุณ เพื่อเพิ่มประสิทธิภาพและลดต้นทุนการดำเนินงาน</div>
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6 col-xl-4 mb-3">
                <div className="card card-dashboard rounded-3 bg-white p-3 border-1" style={{ minHeight: 212 }}>
                  <span className="icon text-60 text-primary">{"\uf648"}</span>
                  <h5 className="fw-bold mb-3 hpx-50">วิเคราะห์และออกแบบระบบธุรกิจ</h5>
                  <span className="text-secondary">ศึกษาและวิเคราะห์กระบวนการทำงานขององค์กร เพื่อออกแบบระบบที่เหมาะสมที่สุด</span>
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-6 col-xl-4 mb-3">
                <div className="card card-dashboard rounded-3 bg-white p-3 border-1" style={{ minHeight: 212 }}>
                  <span className="icon text-60 text-primary">{"\uf0eb"}</span>
                  <h5 className="fw-bold mb-3 hpx-50">พัฒนา Web App, Mobile App, <br/>POS และ IoT</h5>
                  <span className="text-secondary">พัฒนาแอปพลิเคชันและระบบต่างๆ ด้วยเทคโนโลยีที่ทันสมัยและเสถียร</span>
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-6 col-xl-4 mb-3">
                <div className="card card-dashboard rounded-3 bg-white p-3 border-1" style={{ minHeight: 212 }}>
                  <span className="icon text-60 text-primary">{"\uf0c0"}</span>
                  <h5 className="fw-bold mb-3 hpx-50">UX/UI Design ที่ตอบโจทย์การใช้งาน</h5>
                  <span className="text-secondary">ออกแบบประสบการณ์ผู้ใช้ที่ใช้งานง่าย สวยงาม และตอบโจทย์ความต้องการ</span>
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-6 col-xl-4 mb-3">
                <div className="card card-dashboard rounded-3 bg-white p-3 border-1" style={{ minHeight: 212 }}>
                  <span className="icon text-60 text-primary">{"\uf1ad"}</span>
                  <h5 className="fw-bold mb-3 hpx-50">วางระบบ ERP/CRM และระบบองค์กรขนาดใหญ่</h5>
                  <span className="text-secondary">ติดตั้งและปรับแต่งระบบจัดการองค์กรที่ซับซ้อนให้เหมาะสมกับธุรกิจ</span>
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-6 col-xl-4 mb-3">
                <div className="card card-dashboard rounded-3 bg-white p-3 border-1" style={{ minHeight: 212 }}>
                  <span className="icon text-60 text-primary">{"\uf058"}</span>
                  <h5 className="fw-bold mb-3 hpx-50">Cloud Platform, Data, Dev, Security</h5>
                  <span className="text-secondary">บริการครบวงจรด้านโครงสร้างพื้นฐาน รักษาความปลอดภัย และการจัดการข้อมูล</span>
                </div>
              </div>
            </div>
          </div>
        </div>
         {/* SECTION 3 */}
        <div className="w-100 bg-light">
          <div className="container mx-auto p-5">
            <h1 className="fw-bold mb-4 text-center">เหตุผลที่ลูกค้าไว้วางใจเรา</h1>
            <div className="row align-items-center">
               <div className="col-12 col-md-6 mb-3">
                <div className="d-flex mb-4">
                  <span className="icon text-26 text-primary me-3">{"\uf058"}</span>
                  <div><b>ทีมผู้เชี่ยวชาญที่มีประสบการณ์</b><br/>
<span className="text-secondary">ทีมงานของเรามีประสบการณ์ในการพัฒนาระบบมากกว่า 5 ปี</span>
</div>
                </div>
                <div className="d-flex mb-4">
                  <span className="icon text-26 text-primary me-3">{"\uf058"}</span>
                  <div>
<b>เทคโนโลยีที่ทันสมัยและเสถียร</b><br/>
<span className="text-secondary">ใช้เทคโนโลยีล่าสุดที่ได้รับการยอมรับในวงการ</span></div>
                </div>
                <div className="d-flex mb-4">
                  <span className="icon text-26 text-primary me-3">{"\uf058"}</span>
                  <div>
<b>การสนับสนุนหลังการขาย</b><br/>
<span className="text-secondary">ให้การสนับสนุนและดูแลระบบอย่างต่อเนื่อง</span></div>
                </div>
                <div className="d-flex mb-4">
                  <span className="icon text-26 text-primary me-3">{"\uf058"}</span>
                  <div>
<b>ราคาที่เหมาะสมและโปร่งใส</b><br/>
<span className="text-secondary">กำหนดราคาที่เป็นธรรมและไม่มีค่าใช้จ่ายซ่อนเร้น</span></div>
                </div>
                
              </div>
              <div className="col-12 col-md-6 mb-3">
                <div className="card card-dashboard rounded-3 bg-white p-3 pb-0 border-1" style={{ minHeight: 212 }}>
                  <div className="row text-center">
                    <div className="col-12 col-sm-6 mb-4"><h1 className="fw-bold text-primary">5+</h1><span>ปี ประสบการณ์</span></div>
                    <div className="col-12 col-sm-6 mb-4"><h1 className="fw-bold text-primary">50+</h1><span>โครงการ</span></div>
                    <div className="col-12 col-sm-6 mb-4"><h1 className="fw-bold text-primary">20+</h1><span>ลูกค้าธุรกิจ</span></div>
                    <div className="col-12 col-sm-6 mb-4"><h1 className="fw-bold text-primary">99%</h1><span>ความพึงพอใจ</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 6 */}
        <div className="w-100 bg-blue text-white align-content-center">
          <div className="container mx-auto px-4 text-center py-5">
            <div className="my-5">
              <h1 className="fw-bold mb-4">วิสัยทัศน์ของเรา</h1>
              <div className="fw-bold mb-3">“เทคโนโลยีที่ดีควรสนับสนุนธุรกิจ ไม่ใช่สร้างภาระ”</div>
              <div className="mb-4">เรามุ่งมั่นที่จะเป็นพาร์ตเนอร์ที่องค์กรวางใจได้ ในการเปลี่ยนผ่านสู่ยุคดิจิทัลอย่างมีคุณภาพ มีเป้าหมาย และยั่งยืน</div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
